import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getDashboardPath = () => urlHelper('/dashboard');
